import { cl, replaceBodyClassName, replaceBodyClassNameTransition } from '@/utils';
import type { Core } from '@barba/core/dist/core/src/src/core';
import type { ITransitionData, Trigger } from '@barba/core/dist/core/src/src/defs';
import { bus } from '@/bus';
import select from 'dom-select';

export let barba: Core | null = null;
export let busy: boolean = false;

cl('.barba-container').remove('to-load');
let lastScrollY = 0;

export function barbaInit() {
  import('@barba/core').then(({ default: brb }) => {
    barba = brb;

    barba.init({
      timeout: 4000,
      debug: false,
      preventRunning: true,
      cacheFirstPage: true,
      requestError: () => {
        return true;
      },
      prefetchIgnore: [
        '/dashboard',
        '/favorites',
      ],
      cacheIgnore: [
        '/dashboard',
        '/favorites',
      ],
      prevent: ({ href }: any) => {
        return (
          href &&
          (href.indexOf('/actions/') > -1 || !!href.match(/\.(xls|xlsx|doc|docx|pdf)$/)?.length)
        );
      },
      transitions: [
        {
          name: 'filter',
          from: {
            namespace: ['archive-page', 'list-page'],
          },
          to: {
            namespace: ['archive-page', 'list-page'],
          },
          sync: true,
          leave() {
            replaceBodyClassNameTransition('filter');
          },
        },
        {
          name: 'default',
          leave() {
            // replaceBodyClassNameTransition('default');
            // return new Promise((resolve) => {
            //   setTimeout(resolve, 300);
            // });
          },
          enter() {
            window.scrollTo(0, 0);
          }
        },
      ],
    });

    bus.emit('barba_ready', barba);

    barba.hooks.leave((data) => {
      bus.emit('barba_leave', data);
      setBusy(true);
    });

    barba.hooks.enter((data) => {
      bus.emit('barba_enter', data);
      window.htmx.process(data.next.container);

      requestAnimationFrame(() => {
        replaceBodyClassName(data.next.namespace);
      });

      updateColors(data.next.container)
    });

    barba.hooks.after((data) => {
      replaceBodyClassNameTransition('', true);
      cl(data.next.container).remove('to-load');
      bus.emit('barba_after', data);
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });

      checkIfAuth();
      setBusy(false);
    });
  });
}

function checkIfAuth() {
  const authNav = document.querySelector('.auth-nav-logged');
  if (authNav) {
    document.body.dispatchEvent(new CustomEvent('authenticated'));
  }
}

function updateColors(container: HTMLElement) {
  const colors = container.getAttribute('data-colors');
  if (colors) {
    const parsedColors = JSON.parse(colors);
    Object.entries<string>(parsedColors).forEach(([key, value]) => {
      document.body.style.setProperty(`--${key}`, value);
    });
  }
}

export function getCurrentNamespace() {
  const currentCont = select('[data-barba="container"]');
  return currentCont?.getAttribute('data-barba-namespace') || '';
}

export function go({ url, trigger = 'barba', clear = false }: { url: string; trigger?: string, clear?: boolean }) {
  if (barba) {
    if (clear) {
      barba.cache.delete(url);
    }
    barba.go(url, trigger as Trigger).then();
  }
}

export function forceGo({ url, trigger = 'barba', self = false }: { url: string; trigger?: string, self?: boolean }) {
  if (barba) {
    barba.cache.delete(url);
    barba.page(url, trigger as Trigger, null, self).then();
  }
}

export function setBusy(b: boolean) {
  busy = b;
  bus.emit('busy', b);
  if (b) {
    cl(document.body).add('is-busy');
  } else {
    cl(document.body).remove('is-busy');
  }
}
